import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import NotFound from '@/pages/NotFound';

const ProductsPage = lazy(() => import('@/pages/products/page'));
const ProductDetail = lazy(() => import('@/pages/product/page'));
const CategoryPage = lazy(() => import('@/pages/category/page'));
const SellPage = lazy(() => import('@/pages/sell/page'));
const ProductRegisterPage = lazy(() => import('@/pages/sell/register/page'));
const FreeSkillSubmitPage = lazy(() => import('@/pages/skills/submit/page'));
const BlogListPage = lazy(() => import('@/pages/blog/page'));
const BlogPostDetail = lazy(() => import('@/pages/blog-post/page'));
const AdminPage = lazy(() => import('@/pages/admin/page'));
const SignupPage = lazy(() => import('@/pages/signup/page'));
const LoginPage = lazy(() => import('@/pages/login/page'));
const CartPage = lazy(() => import('@/pages/cart/page'));
const CheckoutPage = lazy(() => import('@/pages/checkout/page'));
const OrderSuccessPage = lazy(() => import('@/pages/order/success/page'));
const MyPage = lazy(() => import('@/pages/mypage/page'));
const TermsPage = lazy(() => import('@/pages/terms/page'));
const PrivacyPage = lazy(() => import('@/pages/privacy/page'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/products/:id', element: <ProductDetail /> },
  { path: '/category/:slug', element: <CategoryPage /> },
  { path: '/sell', element: <SellPage /> },
  { path: '/sell/register', element: <ProductRegisterPage /> },
  { path: '/skills/submit', element: <FreeSkillSubmitPage /> },
  { path: '/blog', element: <BlogListPage /> },
  { path: '/blog/:id', element: <BlogPostDetail /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/cart', element: <CartPage /> },
  { path: '/checkout', element: <CheckoutPage /> },
  { path: '/order/success/:id', element: <OrderSuccessPage /> },
  { path: '/mypage', element: <MyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
